<template>
  <div class="feedbackReceived flex row-between flex-wrap">
    <div v-for="(item,index) in feedbackReceivedData" :key="index" class="bg-FF p-24 m-t-20  feedbackReceivedList ">
        <div  class="m-b-24 feedbackReceivedListName ">
            <img src="@/assets/icon/feedbackStatistics/user.png" alt="人员" class="w-42 h-42 m-r-16">
            <div class="userName font-32 text-left">{{ item.nickName }}</div>
            <van-icon name="arrow" size="18" class="m-r-0 cor-33" @click="jumpDetail(item)"/>
        </div>
        <div class="cor-99 font-28">
            <div class="flex row-between m-b-16">参与项目数：<span class="cor-66">{{ item.projectNum }}个</span></div>
            <div class="flex row-between m-b-16">参与任务：<span class="cor-66">{{ item.taskNum }}个</span></div>
            <div class="flex row-between m-b-16">反馈工时：<span class="cor-66">{{ item.feedbackHourTotal }}h</span></div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'feedbackReceived',
  inject: ['feedbackStatisticsProvide'],
  props: {
    feedbackReceivedData: {
      type: Array,
      default: () => {[]},
    },
  },

  data() {
    return {

    }
  },
  created() {
  },
  mounted() {
  },
  methods: {

    //跳转详情
    jumpDetail(item){
      console.log(item)
      console.log(this.feedbackStatisticsProvide.queryParams)
      let query={
        deptId:this.feedbackStatisticsProvide.queryParams.deptId,
        nickName:this.feedbackStatisticsProvide.queryParams.nickName,
        userId:this.feedbackStatisticsProvide.queryParams.userId,
        startTime:this.feedbackStatisticsProvide.queryParams.startTime,
        endTime:this.feedbackStatisticsProvide.queryParams.endTime,
        name:this.feedbackStatisticsProvide.queryParams.name,
        pageNum:this.feedbackStatisticsProvide.queryParams.pageNum,
        pageSize:this.feedbackStatisticsProvide.queryParams.pageSize,
        nickNameItem:item.nickName,
        userIdItem:item.userId,
      }
      this.$router.push({path: '/feedbackReceivedView', query:query})
    }
  }
}
</script>
<style lang="less" scoped>
.feedbackReceived{
  //  display: flex;
  //   flex-direction: row;
  //   flex-wrap: wrap;
  //   justify-content: space-between;
    .feedbackReceivedList{
      width: calc(50% - 10px);
      .feedbackReceivedListName{
           display: flex;
          flex-direction: row;
          align-items: center;
          flex-wrap: nowrap;
          align-content: center;
          justify-content: center;
          .userName{
            width: calc(100% - 40px - 16px - 32px);
          
          }
      }
    .van-icon{
        margin-right: 10px;
    }
    }
}
</style>
